// AXIOS CONFIGURATION
import axios from "axios";
import axiosRetry from "axios-retry";
import { mapActions, mapState } from "vuex";
import router from "../router/index";
import store from "../store";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.timeout = 45000;
axios.defaults.timeoutErrorMessage = "timeout";
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
axios.defaults.headers.common["APP-NAME"] = "KRISHIFY_BRAND_WEB";
axios.defaults.headers.common["APP-VERSION-CODE"] = 1;
axiosRetry(axios, { retries: 3 });

export default {
  computed: {
    ...mapState("mainStore", ["masterLoader"]),
  },

  methods: {
    ...mapActions("mainStore", ["toggleLoader", "refreshToken", "logoutUser"]),

    // AXIOS GET REQUEST
    requestGET(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 45000
    ) {
      axios
        .get(url, {
          baseURL: baseURL,
          timeout: timeout,
          params: params,
          headers: headers,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          console.log(error);
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "GET",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS GET REQUEST
    requestGETwithoutHeader(
      url,
      params,
      headerss = {},
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 45000
    ) {
      delete axios.defaults.headers.common;
      axios
        .get(url, {
          baseURL: baseURL,
          timeout: timeout,
          params: params,
          headers: headerss,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          console.log(error);
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "GET",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS POST REQUEST
    requestPOST(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 45000
    ) {
      axios
        .post(url, params, {
          headers: headers,
          baseURL: baseURL,
          timeout: timeout,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response?.status === 469) {
                const data = {
                  request: "POST",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response?.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response?.status === 403 &&
                error.response?.data?.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS POST REQUEST
    newRequestPOST(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 40000
    ) {
      axios
        .post(url, params, {
          headers: headers,
          timeout: timeout,
          baseURL: baseURL,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "POST",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS POST REQUEST
    requestAWSPOST(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null
    ) {
      axios
        .post(url, params, { headers: headers })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              errorResponse(error);
            }
          }
        });
    },

    // AXIOS PUT REQUEST
    requestPUT(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 240000
    ) {
      axios
        .put(url, params, {
          headers: headers,
          baseURL: baseURL,
          timeout: timeout,
          params: params,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "PUT",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS PATCH REQUEST
    requestPATCH(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null,
      baseURL = process.env.VUE_APP_API_BASE_URL,
      timeout = 80000
    ) {
      axios
        .patch(url, params, {
          headers: headers,
          baseURL: baseURL,
          timeout: timeout,
        })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "PATCH",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // AXIOS DELETE REQUEST
    requestDELETE(
      url,
      params,
      headers,
      successResponse = null,
      errorResponse = null
    ) {
      axios
        .delete(url, { headers: headers }, { data: params })
        .then((response) => {
          if (successResponse) successResponse(response);
        })
        .catch((error) => {
          if (errorResponse) {
            if (error) {
              if (error.message === "timeout") {
                const snackBarData = {
                  textMessage: "Request Timeout, please try again!",
                  color: "error",
                  timeOut: 5000,
                };
                store.dispatch("snackBar/setSnackBar", snackBarData);
                errorResponse(error);
              } else if (error.response.status === 469) {
                const data = {
                  request: "DELETE",
                  url: url,
                  params: params,
                  headers: headers,
                  successResponse: successResponse,
                  errorResponse: errorResponse,
                };
                store.dispatch("mainStore/refreshToken", data); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (error.response.status === 470) {
                store.dispatch("mainStore/logoutUser", 470); // "Store" variable has been explicitly used since in some APIs "this" instance is undefined. Note : Need to find a reason for this.
              } else if (
                error.response.status === 403 &&
                error.response.data.error_type == "PermissionDenied"
              ) {
                router.replace({ name: "verifyCurtain" });
              } else errorResponse(error);
            }
          }
        });
    },

    // FUNCTION THAT TRIGGERS SNACKBAR
    showToast(
      message,
      color = "success",
      timeOut = 5000,
      outlined = false,
      closeButtonColor = "white"
    ) {
      const snackBarData = {
        textMessage: message,
        color: color,
        timeOut: timeOut,
        outlined: outlined,
        closeButtonColor: closeButtonColor,
      };
      store.dispatch("snackBar/setSnackBar", snackBarData);
    },
  },
};
